import { render, staticRenderFns } from "./FormSchema.vue?vue&type=template&id=dd49b2f2&scoped=true&"
import script from "./FormSchema.vue?vue&type=script&lang=js&"
export * from "./FormSchema.vue?vue&type=script&lang=js&"
import style0 from "./FormSchema.vue?vue&type=style&index=0&id=dd49b2f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd49b2f2",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QList from 'quasar/src/components/item/QList.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QExpansionItem,QList,QCheckbox});
